/**
 * This is DEPRECIATED. Please use the new version located at:
 *
 * Path: commonAssets/components/FormBase/index.js
 * Path: commonAssets/components/Forms/SubmitClaim/index.js
 * Path: commonAssets/components/Forms/OptOut/index.js
 */

import { FormBase, ImportantDates } from "./classes";
import {
    createElement,
    modal,
    loadingGif,
    validateField,
    clearMessage,
    toggleFieldError,
    loadMember,
    toggleFieldAttribute,
    toggleForeignPhone,
    ConfirmEmailAddress,
    localDatetime,
    formatPhone,
    generateMd5Hash,
    toggleFieldWarning,
    removeClaimFile,
    uploadFile,
    validOTP,
    createOTPForm,
} from "./helpers";
import { i18n, loading, outputDiv, reCAPTCHAv3 } from "./constants";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";

export class SubmitClaim extends FormBase {
    constructor(
        data,
        language,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null
    ) {
        super(data, language);
        this.customInitClaim = customInitClaim;
        this.customProcessClaim = customProcessClaim;
        this.customLoadMember = customLoadMember;
    }

    async form() {
        try {
            const response = await fetch(this.data);
            const json = await response.json();
            const form = json.claim_form[this.lang];
            this.init_claim(form);
        } catch (error) {
            const e = new ErrorHandler();
            e.display(error);
        }
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                // Claim Deadline - Default Pacific DateTime
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                // Error Handling
                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                /**
                 * Claim Guard
                 */
                if (form.form_options.notice_confirmation.display === true) {
                    // Guard
                    container.appendChild(this.guard(form, datetime));
                    outputDiv.appendChild(container);

                    const zero_zero_id =
                        document.getElementById("zero_zero_id");
                    const confirmation_code =
                        document.getElementById("confirmation_code");
                    const skip_guard = document.getElementById("skip-guard");

                    // Notice Id and Confirmation Code
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        input.addEventListener("change", validateField);
                    });

                    // Skip Guard
                    if (skip_guard) {
                        skip_guard.addEventListener("click", () => {
                            // Hide guard
                            document
                                .getElementById("guard")
                                .classList.add("d-none");
                            // New Claim Form
                            container.appendChild(this.claim_form(form));
                            container.scrollIntoView({ behavior: "smooth" });
                            outputDiv.appendChild(container);

                            // Init claim fields
                            this.init_claim_fields(
                                this.claim,
                                form,
                                claim_deadline
                            );
                        });
                    }

                    // ada compliance updates - added
                    // if input#submit-guard was clicked add .was-verified to form#guard
                    document
                        .getElementById("submit-guard")
                        .addEventListener("click", () => {
                            document
                                .getElementById("guard")
                                .classList.add("was-validated");
                            // TODO: add required text to labels
                        });

                    // Validate Guard Fields
                    document
                        .getElementById("guard")
                        .addEventListener("submit", (e) => {
                            e.preventDefault();

                            let valid = true;
                            const member = {
                                domain: this.claim.data.domain,
                                zero_zero_id: zero_zero_id.value.toUpperCase(),
                                confirmation_code: confirmation_code.value,
                            };

                            clearMessage();

                            // Validate guard fields
                            [zero_zero_id, confirmation_code].forEach(
                                function (input) {
                                    valid = validateField(input) && valid;
                                }
                            );
                            if (!valid) return;

                            loadingGif(loading, "show");

                            // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                            this.claim.api
                                .classMemberPost({}, member)
                                .then((result) => {
                                    // Check for error message
                                    if (result.data.error) {
                                        toggleFieldError(
                                            zero_zero_id,
                                            true,
                                            ""
                                        );
                                        toggleFieldError(
                                            confirmation_code,
                                            true,
                                            ""
                                        );
                                        modal(
                                            i18n.getTranslation("error"),
                                            `<p class="fw-bold">${result.data.error}</p>`
                                        );
                                        loadingGif(loading, "hide", 250);
                                        return;
                                    }

                                    // Add notice id and confirmation code to claim data
                                    this.claim.data.zero_zero_id =
                                        member.zero_zero_id;
                                    this.claim.data.confirmation_code =
                                        member.confirmation_code;

                                    // Define the environment for the OTP
                                    const environment =
                                        this.claim.data.domain.split(".")[0]; // ada compliance - added

                                    // Check for existing claim number and add to claim data
                                    if (result.data.claim_id) {
                                        // ada compliance - changed
                                        this.claim.data.claim_id =
                                            result.data.claim_id;
                                        if (environment !== "local") {
                                            this.send_otp(
                                                form,
                                                container,
                                                result.data,
                                                claim_deadline
                                            );
                                            return;
                                        }
                                    }

                                    // ada compliance updates - added
                                    // Evoke the customLoadMember function, then pass the result.data to the customLoadMember function
                                    if (this.customLoadMember != null) {
                                        this.customLoadMember(result.data);
                                    }

                                    // Populate claim form
                                    this.populate_claim_form(
                                        form,
                                        container,
                                        result.data,
                                        claim_deadline
                                    );
                                })
                                .catch(function (error) {
                                    const e = new ErrorHandler(
                                        "init_claim_catch"
                                    );
                                    e.display(error);
                                });
                        });
                } else {
                    /**
                     * No Claim Guard
                     */
                    // Edit claim link
                    this.edit_claim(form);

                    // New Claim Form
                    container.appendChild(this.claim_form(form));
                    outputDiv.appendChild(container);

                    // Init claim fields
                    this.init_claim_fields(this.claim, form, claim_deadline);
                }
                loadingGif(loading, "hide", 250);
            })
            .catch(function (error) {
                const e = new ErrorHandler();
                e.display(error);
            });
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        // Hide guard
        document.getElementById("guard").classList.add("d-none");

        // New Claim Form
        container.appendChild(this.claim_form(form));
        container.scrollIntoView({ behavior: "smooth" });
        outputDiv.appendChild(container);

        loadingGif(loading, "hide", 250);

        // Load member data into form
        loadMember(class_member);

        if (this.customLoadMember != null) {
            this.customLoadMember(this.claim);
        }

        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    init_claim_fields(claim, form, claim_deadline) {
        // Claim Inputs
        this.init_claim_inputs();

        // Loop thru available inputs
        this.init_claim_inputs_loop();

        // Validate phone number
        this.setup_phone_number_validation();

        // Country field toggle
        this.setup_country_field_toggle();

        // Confirm email address
        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("init");
        }

        // Check for file documentation section
        if (document.getElementById("documentation")) {
            // Initialize file uploads
            this.init_claim_files(this.claim);
        }

        if (Boolean(document.getElementById("form"))) {
            // ada compliance updates - added
            // TODO: review if this is where this belongs
            // if id="submit-claim" is clicked, add was-validated to form class
            document
                .getElementById("submit-claim")
                .addEventListener("click", () => {
                    document
                        .getElementById("form")
                        .classList.add("was-validated");
                });

            document
                .getElementById("form")
                .addEventListener("submit", (process) => {
                    this.process_claim(process, this.claim, claim_deadline);
                });
        }

        if (this.customInitClaim != null) {
            this.claim = this.customInitClaim(this.claim) || this.claim;
        }

        loadingGif(loading, "hide", 1000);
    }

    init_claim_inputs() {
        this.claim.inputs.contact = Array.from(
            document.querySelectorAll(
                "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID"
            )
        );
        this.claim.inputs.fields = Array.from(
            document.querySelectorAll(
                "#claim-fields input, #claim-fields textarea, #claim-fields select"
            )
        );
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(
                "#transactions input, #transactions textarea, #transactions select"
            )
        );
    }

    init_claim_inputs_loop() {
        for (const type in this.claim.inputs) {
            if (this.claim.inputs[type] && this.claim.inputs[type].length > 0) {
                this.claim.inputs[type].forEach(function (field) {
                    // Check for validation attribute
                    if (field.hasAttribute("data-validate")) {
                        // Attach change event handler for validation
                        field.addEventListener("change", function (e) {
                            validateField(field);
                        });
                    }
                });
            }
        }
    }

    /**
     * Initialize the claim files by attaching event listeners to relevant
     * elements.
     *
     * @param {Claim} claim - The claim object.
     * @returns {void}
     */
    init_claim_files(claim) {
        console.log("init_claim_files init...");

        /**
         * Attach an event listener to the 'file-upload' element and perform
         * certain actions when the file selection changes.
         *
         * @param {Event} e - The change event object.
         * @returns {void}
         */
        document
            .getElementById("file-upload")
            .addEventListener("change", function (e) {
                if (validateField(this)) {
                    /* Generate File Hash */
                    generateMd5Hash(this.files[0], claim);
                    document.getElementById("file-description").focus();
                }
            });

        /**
         * Attach an event listener to the 'file-add' element and invoke the
         * 'add_claim_file' method when clicked.
         *
         * @param {Event} e - The click event object.
         * @returns {void}
         */
        document.getElementById("file-add").addEventListener("click", (e) => {
            console.log("file-add init...");
            this.add_claim_file();
        });

        /**
         * Attach an event listener to the 'file-description' element and
         * perform certain actions when a key is pressed.
         *
         * @param {KeyboardEvent} e - The keypress event object.
         * @returns {void}
         */
        document
            .getElementById("file-description")
            .addEventListener("keypress", (e) => {
                if (["Enter", "NumpadEnter"].includes(e.code)) {
                    console.log(e.code);
                    this.add_claim_file();
                    e.preventDefault();
                }
            });
    }

    process_claim(e, claim, deadline) {
        console.log("process_claim init...");

        /**
         * Prevent the default form submission.
         *
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Since: 2023.09.25
         *
         * @returns {void}
         */
        document.getElementById("submit-claim").disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.claim.inputs.contact = Array.from(
            document.querySelectorAll(
                "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID"
            )
        );
        this.claim.inputs.fields = Array.from(
            document.querySelectorAll(
                "#claim-fields input, #claim-fields textarea, #claim-fields select"
            )
        );
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(
                "#transactions input, #transactions textarea, #transactions select"
            )
        );
        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById("documentation")) {
            this.process_claim_files(this.claim);
        }

        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("process", this.claim);
        }

        /**
         * Define the environment for the s3 uploader.
         */
        const s3env = this.config.url;

        // Custom process claim
        if (this.customProcessClaim != null) {
            claim = this.customProcessClaim(this.claim);
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise
                .execute(reCAPTCHAv3, { action: "submit" })
                .then((token) => {
                    claim.data.token = token;
                    this.post_claim(claim, s3env);
                });
        } else {
            document.getElementById("submit-claim").disabled = false;
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_form_errors")
            );
            const error = document.querySelector(
                "input.warning, input.error, select.error, textarea.error, #file-notice.error, #no-files.error"
            );
            if (typeof error.scrollIntoView == "function") {
                error.scrollIntoView({ behavior: "smooth" });
            }
        }
    }

    process_claim_files(claim) {
        console.log("process_claim_files init...");

        const error = document.querySelector(
            'label[for="file-upload"] .error'
        ).innerText;
        const file = document.getElementById("file-upload");

        toggleFieldWarning(file, false);

        if (file.classList.contains("error") && error != "No File Selected") {
            claim.flags.valid = false;
        } else if (file.value != "") {
            toggleFieldWarning(file, true, "Did you forget to add this file?");
            claim.flags.valid = false;
        } else {
            toggleFieldError(file, false);
        }
    }

    add_claim_file(e) {
        console.log(`add_claim_file init...`);
        const claim = this.claim;
        const file = document.getElementById("file-upload");
        const description = document.getElementById("file-description");
        const list = document.getElementById("file-list");
        const fileHash = document.getElementById("file-hash");
        let li;

        if (file.classList.contains("error")) {
            return;
        }

        toggleFieldWarning(file, false);

        toggleFieldError(file, false);
        if (!file.files[0]) {
            toggleFieldError(file, true, "No File Selected");
            return;
        }

        description.value = description.value.trim();

        toggleFieldError(description, false);
        if (!description.value) {
            description.focus();
            toggleFieldError(description, true, "Required");
            return;
        }

        li = document.createElement("li");
        li.innerHTML =
            '<span class="remove"><span></span></span><span class="filename"><strong>' +
            file.files[0].name +
            '</strong></span><span class="description">(' +
            description.value +
            ")</span>";
        list.appendChild(li);

        list.classList.remove("d-none");
        document.getElementById("no-files").classList.add("d-none");

        claim.uploads.push({
            file: file.files[0],
            description: description.value,
            hash: fileHash.value,
        });

        file.value = "";
        description.value = "";
        fileHash.value = "";

        li.querySelector(".remove").addEventListener("click", removeClaimFile);
    }

    format_claim_data(claim) {
        for (var type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    const label =
                        field.getAttribute("data-label") || field.name;
                    const item_id = field.getAttribute("item-id") || null;
                    let data_field;

                    if (
                        field.hasAttribute("data-validate") &&
                        !validateField(field)
                    ) {
                        claim.flags.valid = false;
                    } else {
                        if (item_id) {
                            if (!claim.data[type][item_id])
                                claim.data[type][item_id] = {};
                            data_field = claim.data[type][item_id];
                        } else {
                            data_field = claim.data[type];
                        }
                        switch (field.type) {
                            case "radio":
                                if (field.checked)
                                    data_field[label] = field.value;
                                break;
                            case "checkbox":
                                field.checked
                                    ? (data_field[label] = field.value)
                                    : (data_field = "No");
                                break;
                            default:
                                data_field[label] = field.value;
                        }
                    }
                });
            }
        }
    }

    async post_claim(claim, s3env) {
        console.log("post_claim init...");

        /**
         * Set the claim as sent.
         *
         * @returns {void}
         */
        claim.flags.sent = true;

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Removed: 2023.09.25 (moved to process_claim) due to multiple submissions.
         *
         * @returns {void}
         */
        // document.getElementById('submit-claim').disabled = true;

        /**
         * Wait 0.5 seconds before display loading gif
         * (Lambda in sleep mode)
         *
         * @returns {void}
         */
        const t = window.setTimeout(() => {
            loadingGif(loading, "show");
        }, 250);

        // Update claim if an existing claim id
        if (claim.data.claim_id) {
            claim.flags.method = "claimsPut";
        }

        /**
         * Process the claim uploads and upload the files.
         */
        try {
            if (claim.uploads.length && claim.uploads.length > 0) {
                for (let f = 0; f < claim.uploads.length; f++) {
                    await uploadFile(claim, s3env, claim.uploads[f], f, 0);
                }
            }
        } catch (error) {
            const e = new ErrorHandler();
            e.display(error);
        }

        /**
         * Paul Pomerleau - October 18th, 2023
         * If the device has a local device token it's added to the claim fields before posting
         */
        const deviceToken = localStorage.getItem("X-Device-Token");
        if (deviceToken) claim.data.fields.device_token = deviceToken;

        // Post/Put claims data
        claim.api[claim.flags.method]({}, claim.data)
            .then(async function (result) {
                // Lambda error message
                if (result.data.error) {
                    clearTimeout(t);
                    claim.flags.success = false;
                    modal(i18n.getTranslation("error"), result.data.error);
                    return;
                }

                /**
                 * Save correlation id
                 */
                claim.data.correlation_id = result.data.correlation_id;
                claim.flags.success = true;
            })
            .catch((error) => {
                console.log(error);
                claim.flags.success = false;
                const e = new ErrorHandler();
                e.display_modal(error);
            })
            .finally(() => {
                // debugger;
                clearTimeout(t);
                loadingGif(loading, "hide", 250);
                if (claim.flags.success) {
                    this.destroy_claim(claim);
                } else {
                    document.getElementById("submit-claim").disabled = false;
                    claim.flags.sent = false;
                }

                // Remove editClaim link on Claim Confirmation
                const editClaim = document.getElementById("editClaim");
                if (editClaim !== null) {
                    editClaim.remove();
                }
            });
    }

    edit_claim(params) {
        const notice = createElement(
            "p",
            [],
            [],
            i18n.getTranslation("claim_edit_notice")
        );
        const div = createElement(
            "div",
            {
                class: "my-3 text-center fw-bold text-info-emphasis text-uppercase",
                id: "editClaim",
            },
            [notice]
        );

        const guardRow = createElement(
            "div",
            { class: "row fs-5", id: "guardRow" },
            [this.notice_confirmation(params, "col")]
        );
        const form = createElement(
            "form",
            { class: "needs-validation", id: "guard", method: "post" },
            [guardRow]
        );
        const formContainer = createElement("div", [], [form]);

        outputDiv.appendChild(div);

        document
            .getElementById("editClaimBtn")
            .addEventListener("click", () => {
                modal(
                    i18n.getTranslation("claim_edit_title"),
                    formContainer.innerHTML
                );

                // Allows for DOM to load
                setTimeout(() => {
                    const zero_zero_id =
                        document.getElementById("zero_zero_id");
                    const confirmation_code =
                        document.getElementById("confirmation_code");

                    // Notice Id and Confirmation Code
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        input.addEventListener("change", validateField);
                    });

                    // Validate Guard Fields
                    document
                        .getElementById("guard")
                        .addEventListener("submit", (e) => {
                            div.remove(); // remove the editClaim div upon click

                            e.preventDefault();

                            let valid = true;
                            const member = {
                                domain: this.claim.data.domain,
                                zero_zero_id: zero_zero_id.value.toUpperCase(),
                                confirmation_code: confirmation_code.value,
                            };

                            clearMessage();

                            // Validate guard fields
                            [zero_zero_id, confirmation_code].forEach(
                                function (input) {
                                    valid = validateField(input) && valid;
                                }
                            );
                            if (!valid) return;

                            loadingGif(loading, "show");

                            // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                            this.claim.api
                                .classMemberPost({}, member)
                                .then((result) => {
                                    console.log("Class member data init...");

                                    // Check for error message
                                    if (result.data.error) {
                                        toggleFieldError(
                                            zero_zero_id,
                                            true,
                                            ""
                                        );
                                        toggleFieldError(
                                            confirmation_code,
                                            true,
                                            ""
                                        );
                                        modal(
                                            i18n.getTranslation("error"),
                                            `<p class="fw-bold">${result.data.error}</p>`
                                        );
                                        return;
                                    }

                                    // Add notice id and confirmation code to claim data
                                    this.claim.data.correlation_id =
                                        result.data.correlation_id;
                                    this.claim.data.zero_zero_id =
                                        member.zero_zero_id;
                                    this.claim.data.confirmation_code =
                                        member.confirmation_code;

                                    // Check for existing claim number and add to claim data
                                    if (result.data.claim_id) {
                                        this.claim.data.claim_id =
                                            result.data.claim_id;
                                        this.send_otp();
                                    }

                                    // Hide guard
                                    document
                                        .querySelector(
                                            '[data-bs-dismiss="modal"]'
                                        )
                                        .click();

                                    // Load member data into form
                                    loadMember(result.data);

                                    // Custom load claim
                                    if (this.customLoadMember != null) {
                                        // this.customLoadMember(this.claim); ada compliance updates - commented out
                                        this.customLoadMember(result.data); // ada compliance updates - changed
                                    }

                                    // Payment widget
                                    if (result.data.claim_id) {
                                        if (
                                            document.getElementById(
                                                "payment_method"
                                            ).value
                                        ) {
                                            document
                                                .getElementById("dst-payment")
                                                .classList.add("d-none");
                                            document.getElementById(
                                                "previous_payment_method"
                                            ).innerText =
                                                document.getElementById(
                                                    "payment_method"
                                                ).value;
                                            document
                                                .getElementById(
                                                    "update_payment_toggle"
                                                )
                                                .addEventListener(
                                                    "click",
                                                    function () {
                                                        document
                                                            .getElementById(
                                                                "update_payment_message"
                                                            )
                                                            .classList.add(
                                                                "d-none"
                                                            );
                                                        document
                                                            .getElementById(
                                                                "dst-payment"
                                                            )
                                                            .classList.remove(
                                                                "d-none"
                                                            );
                                                    }
                                                );
                                            document
                                                .getElementById(
                                                    "update_payment_message"
                                                )
                                                .classList.remove("d-none");
                                        }
                                    }

                                    loadingGif(loading, "hide", 250);
                                })
                                .catch(function (error) {
                                    const e = new ErrorHandler();
                                    e.display_modal(error);
                                });
                        });
                }, 1000);
            });
    }

    destroy_claim(claim) {
        loadingGif(loading, "hide", 500); // left here

        if (claim.flags.success) {
            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector("div.display-form").classList.add("d-none");

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            outputDiv.scrollIntoView({ behavior: "smooth" });

            setTimeout(() => {
                modal(
                    i18n.getTranslation("confirmation_screen_additional")[
                        "title"
                    ],
                    i18n.getTranslation("confirmation_screen_additional")[
                        "body"
                    ]
                );
            }, 250);
        } else {
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_submit_error")
            );
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (const type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(
            document.querySelectorAll('input[type="radio"]'),
            function (radio) {
                radio.setAttribute("disabled", "disabled");
            }
        );

        document
            .getElementById("submit-claim")
            .setAttribute("disabled", "disabled");
    }

    claim_data_confirmation(claim) {
        const confirmation = {
            title: i18n.getTranslation("confirmation_page")["title"],
            upload_fail:
                i18n.getTranslation("confirmation_page")["upload_fail"],
            print_note: i18n.getTranslation("confirmation_page")["print_note"],
            claim_details: {
                title: i18n.getTranslation("confirmation_page")[
                    "claim_details"
                ]["title"],
                correlation_id: claim.correlation_id,
                body: i18n.getTranslation("confirmation_page")["claim_details"][
                    "body"
                ],
                footer: i18n.getTranslation("confirmation_page")[
                    "claim_details"
                ]["footer"],
                edit: i18n.getTranslation("confirmation_page")["claim_details"][
                    "edit"
                ],
                excluded_keys: [
                    "Payment Token",
                    "Payment Email",
                    "Payment Phone",
                    "device_token",
                ],
            },
        };
        return confirmation;
    }

    send_otp(form, container, class_member, claim_deadline) {
        const otp_request = {
            authorizationToken: "",
            domain: class_member.domain,
            email_address: class_member.email_address,
        };
        this.claim.api
            .otpGet(otp_request)
            .then((result) => {
                if (result.status != 200) {
                    loadingGif(loading, "hide", 250);
                    modal(
                        i18n.getTranslation("error"),
                        i18n.getTranslation("claim_processing_error")
                    );
                    return;
                }
                loadingGif(loading, "hide", 250);
                modal(
                    i18n.getTranslation("otp_title"),
                    createOTPForm(otp_request.email_address).outerHTML
                );
                setTimeout(() => {
                    const otpFormElement = document.getElementById("otp-form");
                    if (!otpFormElement) {
                        return;
                    }
                    const otp = new VanillaOTP(".otp-inputs");
                    otpFormElement.addEventListener("submit", (e) => {
                        e.preventDefault();
                        if (validOTP(otp.getValue())) {
                            loading.classList.add("show");
                            document.getElementById("submit-otp").disabled =
                                true;
                            this.validate_otp(
                                otp.getValue(),
                                class_member,
                                form,
                                container,
                                claim_deadline
                            );
                        } else {
                            modal(
                                i18n.getTranslation("error"),
                                i18n.getTranslation("otp_validation_error")
                            );
                        }
                    });
                }, 250);
            })
            .catch(function (error) {
                const e = new ErrorHandler();
                e.display_modal(error);
            });
    }

    validate_otp(otp, class_member, form, container, claim_deadline) {
        const otp_request = {
            domain: class_member.domain,
            email_address: class_member.email_address,
            code: otp,
        };
        this.claim.api
            .otpPost({}, otp_request)
            .then((result) => {
                if (result.status == 200) {
                    this.populate_claim_form(
                        form,
                        container,
                        class_member,
                        claim_deadline
                    );
                    document.querySelector('[data-bs-dismiss="modal"]').click();
                }
            })
            .catch(function (error) {
                const e = new ErrorHandler();
                e.display_otp_modal(error);
            });
    }
}

export class OptOut extends FormBase {
    constructor(
        data,
        language,
        i18n,
        enableClaimFields = true,
        enableClaimTransactions = true
    ) {
        super(data, language, i18n);
        this.enableClaimFields = enableClaimFields;
        this.enableClaimTransactions = enableClaimTransactions;
    }

    async form() {
        try {
            const response = await fetch(this.data);
            const json = await response.json();
            const form = json.claim_form[this.lang];
            this.init_exclusion(form);
        } catch (error) {
            const e = new ErrorHandler();
            e.display_modal(error);
        }
    }

    init_exclusion(form) {
        this.exclusion.api
            .exclusionDeadlineGet({ domain: this.exclusion.data.domain })
            .then((result) => {
                // Claim Deadline - Default Pacific DateTime
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let exclusion_deadline;
                if (Boolean(result.data.exclusion_deadline)) {
                    exclusion_deadline = result.data.exclusion_deadline;
                }

                // Error Handling
                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                if (form.form_options.exclusion_form.guard.display) {
                    // Init opt out guard
                    this.init_exclusion_guard(
                        form,
                        container,
                        datetime,
                        exclusion_deadline
                    );
                } else {
                    // New Exclusion Form
                    container.appendChild(this.exclusion_form(form));
                    outputDiv.appendChild(container);

                    // Initiate opt out fields
                    this.init_exclusion_fields();

                    // Submit form
                    document
                        .getElementById("form")
                        .addEventListener("submit", (process) => {
                            this.process_exclusion(
                                process,
                                this.exclusion,
                                exclusion_deadline
                            );
                        });
                }

                loadingGif(loading, "hide", 250);
            })
            .catch(function (error) {
                const e = new ErrorHandler();
                e.display(error);
            });
    }

    init_exclusion_fields(params) {
        this.exclusion.inputs = Array.from(
            document.querySelectorAll(
                "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn,#referer_url, #user_language, #ag_SGUID"
            )
        );
        this.exclusion.inputs.transactions = Array.from(
            document.querySelectorAll(
                "#transactions input, #transactions textarea, #transactions select"
            )
        );

        this.exclusion.inputs.forEach(function (field) {
            // Check for validation attribute
            if (field.hasAttribute("data-validate")) {
                // Attach change event handler for validation
                field.addEventListener("change", function (e) {
                    validateField(field);
                });
            }
        });

        if (
            this.exclusion.inputs.transactions &&
            this.exclusion.inputs.transactions.length > 0
        ) {
            this.exclusion.inputs.transactions.forEach(function (field) {
                // Check for validation attribute
                if (field.hasAttribute("data-validate")) {
                    // Attach change event handler for validation
                    field.addEventListener("change", function (e) {
                        validateField(field);
                    });
                }
            });
        }

        // Validate phone number
        this.setup_phone_number_validation();

        // Country field toggle
        this.setup_country_field_toggle();

        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("init");
        }
    }

    init_exclusion_guard(form, container, datetime, exclusion_deadline) {
        // Guard
        container.appendChild(this.guard(form, datetime));
        outputDiv.appendChild(container);

        const zero_zero_id = document.getElementById("zero_zero_id");
        const confirmation_code = document.getElementById("confirmation_code");
        const skip_guard = document.getElementById("skip-guard");

        // Notice Id and Confirmation Code
        [zero_zero_id, confirmation_code].forEach(function (input) {
            input.addEventListener("change", validateField);
        });

        // Skip Guard
        if (skip_guard) {
            skip_guard.addEventListener("click", () => {
                // Hide guard
                document.getElementById("guard").classList.add("d-none");
                // New Claim Form
                container.appendChild(this.exclusion_form(form));
                container.scrollIntoView({ behavior: "smooth" });
                outputDiv.appendChild(container);

                // Initiate opt out fields
                this.init_exclusion_fields();

                // Submit form
                document
                    .getElementById("form")
                    .addEventListener("submit", (process) => {
                        this.process_exclusion(
                            process,
                            this.exclusion,
                            exclusion_deadline
                        );
                    });
            });
        }

        // Validate Guard Fields
        document.getElementById("guard").addEventListener("submit", (e) => {
            e.preventDefault();

            let valid = true;
            const member = {
                domain: this.claim.data.domain,
                zero_zero_id: zero_zero_id.value.toUpperCase(),
                confirmation_code: confirmation_code.value,
            };

            clearMessage();

            // Validate guard fields
            [zero_zero_id, confirmation_code].forEach(function (input) {
                valid = validateField(input) && valid;
            });
            if (!valid) return;

            loadingGif(loading, "show");

            // Retrieve class member data (use POST to pass notice id and confirmation code privately)
            this.claim.api
                .classMemberPost({}, member)
                .then((result) => {
                    // Check for error message
                    if (result.data.error) {
                        toggleFieldError(zero_zero_id, true, "");
                        toggleFieldError(confirmation_code, true, "");
                        modal(
                            i18n.getTranslation("error"),
                            `<p class="fw-bold">${result.data.error}</p>`
                        );
                        return;
                    }

                    // Add notice id and confirmation code to claim data
                    this.exclusion.data.zero_zero_id = member.zero_zero_id;
                    this.exclusion.data.confirmation_code =
                        member.confirmation_code;

                    // Check for existing claim number and add to claim data
                    if (result.data.claim_id) {
                        this.exclusion.data.claim_id = result.data.claim_id;
                    }

                    // Hide guard
                    document.getElementById("guard").classList.add("d-none");

                    // New Claim Form
                    container.appendChild(this.exclusion_form(form));
                    container.scrollIntoView({ behavior: "smooth" });
                    outputDiv.appendChild(container);

                    loadingGif(loading, "hide", 250);

                    // Load member data into form
                    loadMember(result.data);

                    // Init claim fields
                    this.init_exclusion_fields(this.exclusion, form);

                    // Submit Exclusion
                    document
                        .getElementById("form")
                        .addEventListener("submit", (process) => {
                            this.process_exclusion(
                                process,
                                this.exclusion,
                                exclusion_deadline
                            );
                        });
                })
                .catch(function (error) {
                    const e = new ErrorHandler();
                    e.display_modal(error);
                });
        });
    }

    /**
     * exclusion_form()
     *
     * Generates an exclusion form for a claim with the given parameters.
     *
     * @param {object} params - The parameters for generating the form.
     * @returns {HTMLFormElement} The HTML form element containing the exclusion form.
     */
    exclusion_form(params) {
        // create the exclusion form
        const claimFormElems = [
            createElement(
                "h3",
                {
                    class: "text-center text-decoration-underline mb-3",
                },
                [],
                params.form_options.exclusion_form.title
            ),
            createElement(
                "div",
                {
                    class: "alert alert-info text-dark text-center fw-semibold mb-3",
                    id: "exclusion_form_top_notice",
                },
                [],
                i18n.getTranslation("exclusion_form_top_notice")
            ),
            createElement(
                "div",
                {
                    class: "text-center mb-3",
                },
                [],
                params.form_options.exclusion_form.body
            ),
            this.claim_contact_information(params),
        ];
        // if the claim fields were enabled push to form
        if (this.enableClaimFields) {
            claimFormElems.push(this.claim_fieldset(params));
        }
        // if the transational table is enabled, push to form
        if (this.enableClaimTransactions) {
            claimFormElems.push(this.claim_transactions(params));
        }
        // push the attestation to the form
        claimFormElems.push(
            this.claim_certification(params.form_options.exclusion_form)
        );
        // build the form and add elements
        const form = createElement(
            "form",
            {
                class: "needs-validation",
                id: "form",
                method: "post",
            },
            claimFormElems
        );
        // return the html form
        return form;
    }

    process_exclusion(e, exclusion, deadline) {
        console.log("cancelable?");
        console.log(e.cancelable);
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        // var exclusion = this.exclusion;
        if (exclusion.sent) {
            return;
        }

        clearMessage();

        exclusion.valid = true;

        /**
         * Check exclusion deadline
         *
         * removed: 2023.10.02 due to errors in submission
         *
         * @returns {void}
         */
        // const importantDates = new ImportantDates(deadline);
        // deadline = importantDates.dateTime(deadline);
        // const current_time = importantDates.dateTime(Date());

        // if(deadline < current_time) {
        //     modal(i18n.getTranslation('error'), i18n.getTranslation('deadline_exclude'));
        //     exclusion.valid = false;
        //     return;
        // }

        this.exclusion.inputs = Array.from(
            document.querySelectorAll(
                "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID"
            )
        );
        this.exclusion.inputs.transactions = Array.from(
            document.querySelectorAll(
                "#transactions input, #transactions textarea, #transactions select"
            )
        );
        exclusion.data.contact = {};
        exclusion.data.fields = {};

        exclusion.inputs.forEach(function (field) {
            if (field.hasAttribute("data-validate") && !validateField(field)) {
                exclusion.valid = false;
            } else if (field.type == "radio") {
                if (field.checked) {
                    exclusion.data[field.name] = field.value;
                    exclusion.data.contact[field.name] = field.value;
                }
            } else if (field.type == "checkbox") {
                if (field.checked) {
                    exclusion.data[field.name] = field.value;
                    exclusion.data.contact[field.name] = field.value;
                } else {
                    exclusion.data[field.name] = "No";
                    exclusion.data.contact[field.name] = "No";
                }
            } else {
                //} if (field.value) {
                exclusion.data[field.name] = field.value;
                exclusion.data.contact[field.name] = field.value;
            }
        });

        if (
            exclusion.inputs.transactions &&
            exclusion.inputs.transactions.length > 0
        ) {
            exclusion.inputs.transactions.forEach(function (field) {
                const label = field.getAttribute("data-label") || field.name;
                const item_id = field.getAttribute("item-id") || null;

                if (
                    field.hasAttribute("data-validate") &&
                    !validateField(field)
                ) {
                    exclusion.flags.valid = false;
                } else if (field.type == "radio") {
                    if (field.checked) {
                        if (item_id) {
                            if (!exclusion.data.transactions[item_id]) {
                                exclusion.data.transactions[item_id] = {};
                            }
                            exclusion.data.transactions[item_id][label] =
                                field.value;
                        } else {
                            exclusion.data.transactions[label] = field.value;
                        }
                    }
                } else if (field.type == "checkbox") {
                    if (field.checked) {
                        if (item_id) {
                            if (!exclusion.data.transactions[item_id]) {
                                exclusion.data.transactions[item_id] = {};
                            }
                            exclusion.data.transactions[item_id][label] =
                                field.value;
                        } else {
                            exclusion.data.transactions[label] = field.value;
                        }
                    } else {
                        if (item_id) {
                            if (!exclusion.data.transactions[item_id]) {
                                exclusion.data.transactions[item_id] = {};
                            }
                            exclusion.data.transactions[item_id][label] = "No";
                        } else {
                            exclusion.data.transactions[label] = "No";
                        }
                    }
                } else {
                    //} if (field.value) {
                    if (item_id) {
                        if (!exclusion.data.transactions[item_id]) {
                            exclusion.data.transactions[item_id] = {};
                        }
                        exclusion.data.transactions[item_id][label] =
                            field.value;
                    } else {
                        exclusion.data.transactions[label] = field.value;
                    }
                }
            });
        }

        if (!exclusion.valid) {
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("exclusion_form_error")
            );
            return;
        }

        exclusion.sent = true;
        document.getElementById("submit-claim").disabled = true;

        loadingGif(loading, "show");

        exclusion.api
            .exclusionPost({}, exclusion.data)
            .then((result) => {
                if (result.data.error) {
                    loadingGif(loading, "hide", 250);
                    exclusion.success = false;
                    const e = new ErrorHandler();
                    e.display_modal(result.data.error);
                    exclusion.inputs.forEach((field) => {
                        field.disabled = true;
                    });
                    return;
                }
                exclusion.success = true;
            })
            .catch((error) => {
                console.log(error);
                exclusion.success = false;
                const e = new ErrorHandler();
                e.display_modal(error);
            })
            .finally(() => {
                loadingGif(loading, "hide", 250);

                if (exclusion.success) {
                    exclusion.data.confirmation =
                        this.exclusion_data_confirmation(exclusion.data);
                    document
                        .querySelector("div.display-form")
                        .classList.add("d-none");

                    outputDiv.appendChild(
                        this.exclusion_confirmation(exclusion.data)
                    );
                    outputDiv.scrollIntoView({ behavior: "smooth" });
                } else {
                    modal(
                        i18n.getTranslation("error"),
                        i18n.getTranslation("exclusion_submit_error")
                    );
                }

                // Loop thru each input and disable to prevent changes and resubmissions
                exclusion.inputs.forEach((field) => {
                    field.disabled = true;
                });

                [].forEach.call(
                    document.querySelectorAll('input[type="radio"]'),
                    function (radio) {
                        radio.setAttribute("disabled", "disabled");
                    }
                );

                document
                    .getElementById("submit-claim")
                    .setAttribute("disabled", "disabled");
            });
    }

    exclusion_data_confirmation(exclusion) {
        const confirmation = {
            title: i18n.getTranslation("confirmation_exclusion_page")["title"],
            upload_fail: i18n.getTranslation("confirmation_exclusion_page")[
                "upload_fail"
            ],
            print_note: i18n.getTranslation("confirmation_exclusion_page")[
                "print_note"
            ],
            claim_details: {
                title: i18n.getTranslation("confirmation_exclusion_page")[
                    "claim_details"
                ]["title"],
                body: i18n.getTranslation("confirmation_exclusion_page")[
                    "claim_details"
                ]["body"],
                footer: i18n.getTranslation("confirmation_exclusion_page")[
                    "claim_details"
                ]["footer"],
                edit: i18n.getTranslation("confirmation_exclusion_page")[
                    "claim_details"
                ]["edit"],
                excluded_keys: [],
            },
        };
        return confirmation;
    }
}
